import { __extends } from "tslib";
import React from 'react';
import classnames from 'classnames';
import ScrollableContent from '../ScrollableContent';
var StreamableList = /** @class */ (function (_super) {
    __extends(StreamableList, _super);
    function StreamableList() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            isScrolled: false,
            isScrolledToBottom: false,
        };
        _this.initialFetch = function () {
            var _a = _this.props, skipInitialFetch = _a.skipInitialFetch, isEmpty = _a.isEmpty, isFetching = _a.isFetching, hasMore = _a.hasMore, fetchMore = _a.fetchMore, streamId = _a.streamId;
            if (!skipInitialFetch && !isFetching && hasMore && isEmpty) {
                fetchMore(streamId);
            }
        };
        _this.onListScroll = function (scrollTop, distanceToBottom) {
            var _a = _this.props, isFetching = _a.isFetching, hasError = _a.hasError, hasMore = _a.hasMore, fetchMore = _a.fetchMore, streamId = _a.streamId, onScrolled = _a.onScrolled, _b = _a.loadMoreDistance, loadMoreDistance = _b === void 0 ? 80 : _b, 
            // use isEmpty as a 'hasBeenInitialized' and don't try to
            // fetch more (which can happen if the container is small
            // enough to trigger the distance check below)
            isEmpty = _a.isEmpty;
            var _c = _this.state, isScrolled = _c.isScrolled, isScrolledToBottom = _c.isScrolledToBottom;
            if (!isEmpty &&
                distanceToBottom < loadMoreDistance &&
                !isFetching &&
                !hasError &&
                hasMore) {
                fetchMore(streamId);
            }
            var isScrolledNew = scrollTop !== 0;
            var isScrolledBottomNew = distanceToBottom < 1;
            if (isScrolled !== isScrolledNew ||
                isScrolledToBottom !== isScrolledBottomNew) {
                // let's only update state when something actually changed because things can get laggy
                _this.setState({
                    isScrolled: isScrolledNew,
                    isScrolledToBottom: isScrolledBottomNew,
                });
            }
            onScrolled && onScrolled(scrollTop, distanceToBottom);
        };
        return _this;
    }
    StreamableList.prototype.componentDidMount = function () {
        this.initialFetch();
    };
    StreamableList.prototype.componentDidUpdate = function (prevProps) {
        if (prevProps.streamId !== this.props.streamId) {
            this.initialFetch();
        }
    };
    StreamableList.prototype.render = function () {
        var _a = this.props, id = _a.id, role = _a.role, children = _a.children, className = _a.className, wrapperClassName = _a.wrapperClassName, scrolledClassName = _a.scrolledClassName, bottomedClassName = _a.bottomedClassName, _b = _a.throttleTimeout, throttleTimeout = _b === void 0 ? 300 : _b, innerRef = _a.innerRef;
        var _c = this.state, isScrolled = _c.isScrolled, isScrolledToBottom = _c.isScrolledToBottom;
        return (React.createElement(ScrollableContent, { id: id, role: role, className: className, throttleTimeout: throttleTimeout, onScrolled: this.onListScroll, wrapperClassName: classnames(wrapperClassName, isScrolled && scrolledClassName, isScrolledToBottom && bottomedClassName), innerRef: innerRef }, children));
    };
    return StreamableList;
}(React.Component));
export { StreamableList };
export default StreamableList;
//# sourceMappingURL=StreamedList.js.map